/**
 * useMediaQuery — subscribe to a CSS media query from React.
 *
 * Used to switch component structure (not just styling) at breakpoints — e.g.
 * DataGrid -> CardList below `lg`, and the thumb-rail -> left-rail nav. Content
 * changes that CSS alone can't express live here.
 */
import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  const subscribe = (cb: () => void) => {
    const mql = window.matchMedia(query);
    mql.addEventListener("change", cb);
    return () => mql.removeEventListener("change", cb);
  };
  const getSnapshot = () => window.matchMedia(query).matches;
  // SSR-safe default (we don't SSR, but keep the signature honest).
  const getServerSnapshot = () => false;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** Convenience: true at Tailwind `lg` (1024px) and up — desktop chrome. */
export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 1024px)");
}
